export default __webpack_public_path__ + "static/media/segundoRouter.6a4a3e39.png";